import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<CreateIndex @formData={{@model.formData}} @poll={{@model.poll}} />",{ moduleName: "croodle/templates/create/index.hbs" })